export default __webpack_public_path__ + "static/media/zeppelin_zepelin_1.320325d5.png";